var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.showlist
      ? _c(
          "div",
          {
            staticClass: "rg-mask",
            on: {
              click: function ($event) {
                if ($event.target !== $event.currentTarget) {
                  return null
                }
                return _vm.close.apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "rg-modal" }, [
              _c(
                "div",
                { staticClass: "rg-header" },
                [
                  _vm.current
                    ? [
                        _c(
                          "button",
                          {
                            staticClass: "rg-btn",
                            on: { click: _vm.closeViewer },
                          },
                          [_vm._v("← Gallery")]
                        ),
                        _c("span", { staticClass: "rg-title rg-ellipsis" }, [
                          _vm._v(_vm._s(_vm.current.report_actual_name)),
                        ]),
                        _c("span", { staticClass: "rg-count" }, [
                          _vm._v(
                            _vm._s(_vm.viewIndex + 1) +
                              " / " +
                              _vm._s(_vm.files.length)
                          ),
                        ]),
                      ]
                    : [
                        _c("span", { staticClass: "rg-title" }, [
                          _vm._v("Uploaded Reports"),
                        ]),
                        _c("span", { staticClass: "rg-count" }, [
                          _vm._v(
                            _vm._s(_vm.files.length) +
                              " " +
                              _vm._s(_vm.files.length === 1 ? "file" : "files")
                          ),
                        ]),
                      ],
                  _c(
                    "button",
                    {
                      staticClass: "rg-x",
                      attrs: { "aria-label": "Close" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("×")]
                  ),
                ],
                2
              ),
              !_vm.current
                ? _c("div", { staticClass: "rg-body" }, [
                    !_vm.files.length
                      ? _c("div", { staticClass: "rg-empty" }, [
                          _vm._v("No files have been added so far."),
                        ])
                      : _c(
                          "div",
                          { staticClass: "rg-grid" },
                          _vm._l(_vm.files, function (f, i) {
                            return _c(
                              "div",
                              { key: f._key, staticClass: "rg-card" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "rg-thumb",
                                    on: {
                                      click: function ($event) {
                                        return _vm.openViewer(i)
                                      },
                                    },
                                  },
                                  [
                                    f._type !== "pdf" &&
                                    _vm.urls[f._key] &&
                                    !_vm.failed[f._key]
                                      ? _c("img", {
                                          attrs: {
                                            src: _vm.urls[f._key],
                                            alt: "",
                                          },
                                          on: {
                                            error: function ($event) {
                                              return _vm.$set(
                                                _vm.failed,
                                                f._key,
                                                true
                                              )
                                            },
                                          },
                                        })
                                      : _c(
                                          "div",
                                          { staticClass: "rg-fileicon" },
                                          [
                                            _c(
                                              "svg",
                                              {
                                                attrs: {
                                                  viewBox: "0 0 24 24",
                                                  width: "40",
                                                  height: "40",
                                                  fill: "none",
                                                  stroke: "currentColor",
                                                  "stroke-width": "1.5",
                                                },
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z",
                                                  },
                                                }),
                                                _c("polyline", {
                                                  attrs: {
                                                    points: "14 2 14 8 20 8",
                                                  },
                                                }),
                                              ]
                                            ),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  f._type === "pdf"
                                                    ? "PDF"
                                                    : _vm.urls[f._key]
                                                    ? "File"
                                                    : "…"
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                  ]
                                ),
                                _c("div", { staticClass: "rg-meta" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "rg-name rg-ellipsis",
                                      attrs: { title: f.report_actual_name },
                                    },
                                    [_vm._v(_vm._s(f.report_actual_name))]
                                  ),
                                  _c("div", { staticClass: "rg-date" }, [
                                    _vm._v(_vm._s(f.commondate)),
                                  ]),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "rg-view",
                                      on: {
                                        click: function ($event) {
                                          return _vm.openViewer(i)
                                        },
                                      },
                                    },
                                    [_vm._v("View")]
                                  ),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                  ])
                : _c("div", { staticClass: "rg-viewer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "rg-nav rg-prev",
                        attrs: { disabled: _vm.viewIndex === 0 },
                        on: {
                          click: function ($event) {
                            return _vm.go(-1)
                          },
                        },
                      },
                      [_vm._v("‹")]
                    ),
                    _c(
                      "div",
                      { staticClass: "rg-stage" },
                      [
                        !_vm.urls[_vm.current._key] &&
                        !_vm.failed[_vm.current._key]
                          ? _c("div", { staticClass: "rg-empty" }, [
                              _vm._v("Loading…"),
                            ])
                          : _vm.failed[_vm.current._key] &&
                            _vm.current._type !== "pdf"
                          ? _c("div", { staticClass: "rg-empty" }, [
                              _vm._v(
                                "\n            Preview not available.\n            "
                              ),
                              _vm.urls[_vm.current._key]
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.urls[_vm.current._key],
                                        target: "_blank",
                                        rel: "noopener",
                                      },
                                    },
                                    [_vm._v("Open in new tab")]
                                  )
                                : _vm._e(),
                            ])
                          : [
                              _vm.current._type === "pdf"
                                ? _c("iframe", {
                                    staticClass: "rg-pdf",
                                    attrs: { src: _vm.urls[_vm.current._key] },
                                  })
                                : _c("img", {
                                    attrs: {
                                      src: _vm.urls[_vm.current._key],
                                      alt: "",
                                    },
                                    on: {
                                      error: function ($event) {
                                        return _vm.$set(
                                          _vm.failed,
                                          _vm.current._key,
                                          true
                                        )
                                      },
                                    },
                                  }),
                              _c("div", { staticClass: "rg-info" }, [
                                _c("span", [
                                  _vm._v(
                                    "Timestamp: " +
                                      _vm._s(_vm.current.commondate)
                                  ),
                                ]),
                                _vm.current._type === "pdf"
                                  ? _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: _vm.urls[_vm.current._key],
                                          target: "_blank",
                                          rel: "noopener",
                                        },
                                      },
                                      [_vm._v("Open in new tab")]
                                    )
                                  : _vm._e(),
                                _vm.featuresNoted
                                  ? _c("div", [
                                      _c("strong", [
                                        _vm._v("Signs/Features Noted"),
                                      ]),
                                      _c("p", [
                                        _vm._v(_vm._s(_vm.featuresNoted)),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm.inference
                                  ? _c("div", [
                                      _c("strong", [_vm._v("Inference")]),
                                      _c("p", [_vm._v(_vm._s(_vm.inference))]),
                                    ])
                                  : _vm._e(),
                              ]),
                            ],
                      ],
                      2
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "rg-nav rg-next",
                        attrs: {
                          disabled: _vm.viewIndex === _vm.files.length - 1,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.go(1)
                          },
                        },
                      },
                      [_vm._v("›")]
                    ),
                  ]),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }